import React, {useEffect} from 'react';
import Product from './Product';
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {albumSelector, getOneAlbum} from '../../../features/album/albumSlice';

function Details() {
  const {id} = useParams();
  const {data, status, error} = useSelector(albumSelector);

  const dispatch = useDispatch();
  useEffect(() => {
    return dispatch(getOneAlbum({id}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      {status === 'loading' ? (
        <h2>Loading...</h2>
      ) : error ? (
        <h2>{error}</h2>
      ) : (
        <Product
          id={data._id}
          title={data.title}
          price={data.price}
          image={data.imageUrl}
          tracks={data.songs}
          countInStock={data.countInStock}
          reviews={data.reviews}
        />
      )}
    </div>
  );
}

export default Details;
